import toString from "lodash/toString"
import { makeStyles } from "tss-react/mui"
import { Box } from "component-lib/Base/components/Box"
import Grid from "component-lib/Base/components/Grid"
import Typography from "component-lib/Base/components/Typography"
import {
  getAdobeLaunchAttribute,
  getAdobeLaunchClassName,
  updateClicksDL,
} from "utils-lib/analytics"
import BaseSwitch from "./BaseSwitch"
import "./MyWMSwitch.scss"

const useStyles = makeStyles()((theme, { checked, disabled }) => {
  let rootStyles = {
    "& .MuiSwitch-thumb": {
      color: theme.palette.switch.inactiveThumb,
    },
    "& .MuiSwitch-track": {
      color: theme.palette.switch.inactiveTrack,
      backgroundColor: theme.palette.switch.inactiveTrack,
      opacity: 1,
    },
  }
  if (disabled) {
    rootStyles = {
      "& .MuiSwitch-thumb": {
        color: `${theme.palette.switch.disabledThumb}`,
      },
      "& .MuiSwitch-track": {
        color: `${theme.palette.switch.disabledTrack}`,
        backgroundColor: `${theme.palette.switch.disabledTrack}`,
        opacity: 1,
      },
    }
  }
  if (checked) {
    rootStyles = {
      "& .MuiSwitch-thumb": {
        color: theme.palette.switch.activeThumb,
      },
      "& .MuiSwitch-track": {
        color: theme.palette.switch.activeTrack,
        backgroundColor: theme.palette.switch.activeTrack,
        opacity: 0.6,
      },
      "& .Mui-focusVisible": {
        outline: `1px solid ${theme.palette.switch.activeThumb}`,
      },
    }
  }

  return {
    root: {
      ...rootStyles,
    },
    wrapperClass: {
      padding: `4px 0`,
    },
  }
})

const MyWMSwitch = ({
  analytics_key,
  shouldNotTrackInComponent,
  isSCA,
  scaValues,
  setSCAValues,
  leftChoice = "",
  rightChoice = "",
  checked,
  onToggle,
  disabled = false,
  elementType = `Switch`,
  customerId = ``,
}) => {
  const { classes } = useStyles({ checked, disabled })

  let clickLabel = ``
  if (typeof analytics_key === `string` && analytics_key !== ``) {
    clickLabel = analytics_key
  } else {
    clickLabel = `Switch Component`
  }

  let switchState = ``
  if (checked && leftChoice) {
    switchState = leftChoice
  } else if (!checked && rightChoice) {
    switchState = rightChoice
  } else {
    switchState = toString(checked)
  }

  const analyticsClass = getAdobeLaunchClassName({
    disabled: shouldNotTrackInComponent,
    isSCA,
  })

  const handleClick = () => {
    if (!shouldNotTrackInComponent) {
      updateClicksDL({
        ui_element: elementType,
        object_content: clickLabel,
      })

      if (isSCA) {
        setSCAValues(scaValues)
      }
    }

    /* Call the onClick handler. */
    onToggle(!checked)
  }

  return (
    <Box data-testid="Switch">
      <Grid
        component="label"
        container
        alignItems="center"
        spacing={1}
        wrap="nowrap"
        className="my-0"
      >
        {leftChoice && (
          <Grid item className="pt-0">
            <Typography>{leftChoice}</Typography>
          </Grid>
        )}
        <Grid container spacing={0} aria-label={analytics_key}>
          <BaseSwitch
            disableRipple
            className={classes.root}
            classes={{
              input: analyticsClass,
            }}
            inputProps={{
              ...getAdobeLaunchAttribute({
                disabled: shouldNotTrackInComponent,
                value: `${clickLabel},${switchState}`,
              }),
              "aria-label": `${clickLabel} ${switchState} for ${customerId}`,
            }}
            disabled={disabled}
            checked={checked}
            onChange={handleClick}
          />
        </Grid>
        {rightChoice && (
          <Grid item className="pt-0">
            <Typography>{rightChoice}</Typography>
          </Grid>
        )}
      </Grid>
    </Box>
  )
}

// Note: React 19 no-longer supports propTypes. Leaving this for reference.
// MyWMSwitch.propTypes = {
//   id: PropTypes.string.isRequired,
//   analytics_key: PropTypes.string.isRequired,
//   ariaExpanded: PropTypes.bool.isRequired,
//   shouldNotTrackInComponent: PropTypes.bool.isRequired,
//   isSCA: PropTypes.bool.isRequired,
//   scaValues: PropTypes.object.isRequired,
//   setSCAValues: PropTypes.func.isRequired,
//   leftChoice: PropTypes.string,
//   rightChoice: PropTypes.string,
//   checked: PropTypes.bool.isRequired,
//   onToggle: PropTypes.func.isRequired,
//   disabled: PropTypes.bool,
//   className: PropTypes.string,
//   style: PropTypes.object,
//   hide: PropTypes.bool,
//   elementType: PropTypes.string,
// }

// Note: React 19 no-longer supports defaultProps. Leaving this for reference.
// MyWMSwitch.defaultProps = {
//   hide: false,
//   className: ``,
//   style: {},
//   disabled: false,
//   elementType: `Switch`,
//   leftChoice: "",
//   rightChoice: "",
// }

export default MyWMSwitch
